import React, { Component } from 'react'

import TradelineForm from './tradelineForm'

import { Loan } from './types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  fetchLoan: Callback
  loan: Loan
  updateLoan: Callback
}

export class UnderwritingTradelineSummary extends Component<Props> {
  onSubmit = ({ adjustments, adminNote }) => {
    const { loan, updateLoan } = this.props
    const tradelineOverrides = adjustments
      .map((adj: string, index: number) => `${index}|${adj}`)
      .filter((id: any) => id)

    updateLoan(loan, { redecision: true, adminNote, tradelineOverrides })
  }

  render() {
    const { loan } = this.props
    if (!loan) return null
    if (Object.keys(loan).length === 0) return null

    return (
      <div>
        <div className="content tradeline-summary">
          <TradelineForm loan={loan} onSubmit={this.onSubmit} />
        </div>
      </div>
    )
  }
}
